// Vue
import Vue from "vue";
import App from "./App";

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
// 核心插件
import d2Admin from "@/plugin/d2admin";
// store
import store from "@/store/index";
import dateMixin from "@/views/utils/formatTodayDate";
Vue.mixin(dateMixin);
import dateUtil from "@/views/utils/dateUtil";
Vue.mixin(dateUtil);

import "@/views/FieldList/WorkSectionList.js";
import { percentFilter } from "@/views/utils/filters";
Vue.filter("percent", percentFilter);

import { fixDecimal } from "@/views/utils/formatNumber";
Vue.filter("fixDecimal", fixDecimal);

// 菜单和路由设置
import router from "./router";
import { frameInRoutes } from "@/router/routes";

//axios异步请求
import axios from "axios";
Vue.prototype.$axios = axios;

//引入Lodash的js工具库
import _ from "lodash";
Vue.prototype._ = _;

//vxe-table第三方表格
import "@/plugin/vxe-table/index.js";

//引入md5
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

//引入aes加密组件
import cryptoJS from "@/libs/util.cryptoJS.js";
Vue.prototype.$cryptoJS = cryptoJS;
import { extractVxeTableColumns } from "@/views/utils/tableHelper";
Vue.prototype.$extractTableColumns = extractVxeTableColumns;

//引入剪切板功能
import VueClipboard from "vue-clipboard2";

//引入cookies组件
import util from "@/libs/util.js";
Vue.prototype.$util = util;

//引入websocket
import ws from "@/plugin/websocket";
Vue.prototype.$ws = ws;

import "@/style/index.css";
import { decimalFilter } from "@/views/utils/formatNumber";

// 核心插件
Vue.use(d2Admin);
Vue.use(VueClipboard);

// 全局过滤器
Vue.filter("formatDate", function(value) {
  if (!value) return;
  const [day, month, year, time] = value.split(" ");
  const formatted = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  return formatted;
});

// 注册全局过滤器(9999=>9,999)
Vue.filter("formatNumber", function(num) {
  if (!num) return "";
  return num.toLocaleString();
});

import i18n from "./lang";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    this.$store.commit("d2admin/page/init", frameInRoutes);
  },
  mounted() {
    this.$store.commit("d2admin/releases/versionShow");
    this.$store.dispatch("d2admin/account/load");
    this.$store.commit("d2admin/ua/get");
    this.$store.dispatch("d2admin/fullscreen/listen");
  }
}).$mount("#app");
